import { BrowserRouter, Routes, Route, Link, Navigate, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { supabase } from "./supabaseClient";

import Landing from "./pages/LandingPage";      // <— your landing page
import Auth from "./pages/Auth";
import Dashboard from "./pages/Dashboard";
import CheckoutSuccess from "./pages/CheckoutSuccess";
import "./styles/App.css";

import AboutPage from "./pages/AboutPage";
import "./pages/AboutPage.css";

import DfyPage from "./pages/DfyPage"

import NavBar from "./components/Navbar";
import Terms from "./pages/terms";

import DfySuccess from "./pages/DfySuccess";


// Simple auth gate for protected routes
function RequireAuth({ children }) {
  const [ready, setReady] = useState(false);
  const [authed, setAuthed] = useState(false);
  const loc = useLocation();

  useEffect(() => {
    supabase.auth.getUser().then(({ data }) => {
      setAuthed(!!data?.user);
      setReady(true);
    });
  }, []);

  if (!ready) return null; // or a loader/spinner

  return authed ? children : (
    <Navigate to={`/auth?mode=login&next=${encodeURIComponent(loc.pathname)}`} replace />
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Landing is now your home route */}
        <Route path="/" element={<Landing />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/dfy" element={<DfyPage />} />
        <Route path="/dfy-success" element={<DfySuccess />} />


        {/* Auth screen (supports ?mode=login|signup) */}
        <Route path="/auth" element={<Auth />} />
        <Route path="/terms" element={<Terms />} />

        {/* Protected dashboard */}
        <Route
          path="/dashboard"
          element={
            <RequireAuth>
              <Dashboard />
            </RequireAuth>
          }
        />

        <Route path="/checkout-success" element={<CheckoutSuccess />} />

        {/* Fallback */}
        <Route
          path="*"
          element={
            <div style={{ padding: 24 }}>
              <h2>Not found</h2>
              <Link to="/">Go Home</Link>
            </div>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}
